import React from 'react'
import { rem } from 'polished'
import styled, { keyframes } from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { bezierCurve } from 'styles/tools/constants'
import cn from 'clsx'
import { getSVGImageUrl } from 'lib/image/imageUtils'
import GoogleLongLogo from 'components/Common/TrustIndicators/GoogleLongLogo'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import Group from 'components/utils/Group'

const ItemTransition = keyframes`
  0% {
    transform: translateX(0);
  }

  45% {
    transform: translateX(0);
  }

  /* Transition to slide 2 */

  50% {
    transform: translateX(-100%);
  }

  95% {
    transform: translateX(-100%);
  }

  /* Transition to slide 1 */

  100% {
    transform: translateX(0);
  }
`

const USPs = styled.div`
  display: grid;
  overflow: visible;
  animation: ${ItemTransition} 6s ${bezierCurve} infinite;
  grid-template-columns: repeat(2, 100%);
  width: 100%;

  ${mediaQueryUp.tablet} {
    animation: none;
    grid-template-areas:
      "atol"
      "google";
    grid-template-columns: unset;
    gap: ${rem(8)};

    .atol-logo {
      grid-area: atol;
      display: flex;
      justify-content: center;
    }
    .google-logo {
      grid-area: google;
    }

    &.is-sign-up-modal {
      grid-template-columns: repeat(2, auto);
      grid-template-areas:
      "atol google";
      grid-gap: ${rem(16)};
    }
  }
`

const BubbleTransition = keyframes`
  0% {
    width: ${rem(16)};
  }

  45% {
    width: ${rem(16)};
  }

  50% {
    width: ${rem(8)};
  }

  95% {
    width: ${rem(8)};
  }

  100% {
    width: ${rem(16)};
  }
`

const BubbleProgressTransition = keyframes`
  0% {
    transform: translateX(-100%);
    opacity: 1;
  }

  /* Slide across the bubble */

  45% {
    transform: translateX(0%);
    opacity: 1;
  }

  /* Fade out as we change slides */

  50% {
    transform: translateX(0%);
    opacity: 0;
  }

  /* Wait for our turn again */

  100% {
    transform: translateX(-100%);
    opacity: 0;
  }
`

const CarouselBubbles = styled.div`
  display: flex;
  justify-content: center;
  gap: ${rem(4)};

  ${mediaQueryUp.tablet} {
    display: none;
  }
`

const CarouselBubble = styled.div`
  position: relative;
  height: ${rem(8)};
  width: ${rem(8)};
  border-radius: ${props => props.theme.borderRadius.round};
  background-color: ${props => props.theme.palette.neutral.default.eight};
  animation: ${BubbleTransition} 6s infinite;
  border: 1px solid ${props => props.theme.palette.neutral.default.one};
  overflow: hidden;
  transform: translateZ(0);

  &:nth-child(2) {
    animation-delay: 3s;

    &::after {
      animation-delay: 3s;
    }
  }


  &::after {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    transform: translateX(-100%);
    background-color: ${props => props.theme.palette.neutral.default.one};
    animation: ${BubbleProgressTransition} 6s infinite;
  }
`

const AnimationContainer = styled.div`
  overflow: hidden;
`

export function TrustIndicatorUK() {
  return (
    <AnimationContainer>
      <USPs className={cn('is-sign-up-modal')}>
        <Group className="atol-logo" direction="horizontal" gap={4} verticalAlign="center" horizontalAlign="center">
          <img src={getSVGImageUrl('984lj4elpskyg828z90qb')} width={20} height={20} alt="" />
          <BodyTextBlock colour="neutral-two" weight="bold" variant="medium" wrap="no-wrap">ATOL protected</BodyTextBlock>
        </Group>
        <Group className="google-logo" direction="horizontal" gap={4} verticalAlign="center" horizontalAlign="center">
          <GoogleLongLogo width="54" height="18" />
          <BodyTextBlock colour="neutral-two" variant="medium" weight="bold">4.7/5</BodyTextBlock>
        </Group>
      </USPs>
      <CarouselBubbles>
        <CarouselBubble />
        <CarouselBubble />
      </CarouselBubbles>
    </AnimationContainer>
  )
}
